import PageviewIcon from '@material-ui/icons/Pageview';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
} from 'candy-commons-components';

import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';

const DiscoverCategoriesCreate = (props) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.discover-categories.name'),
            url: 'discover-categories',
            icon: <PageviewIcon />,
        },
        {
            text: translation('resources.discover-categories.create.name'),
            url: '',
        },
    ];

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm>
                    <ContainerFieldsList>
                        <TextInput
                            source="categoryName"
                            validate={required()}
                        />
                        <TextInput source="categoryKey" validate={required()} />
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};
export default DiscoverCategoriesCreate;
